import React, { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!token && location.pathname === '/dashboard') {
      navigate('/');
    }
  }, [token, navigate, location.pathname]);

  return token ? <>{children}</> : null; // Don't render anything if no token, Navigate handles redirection
};

export default ProtectedRoute;